import type { Asset } from '@schibsted-svp/svp-api-types';
import { relatedApi } from '../api';

const relatedService = {
    getRelatedAssets: async ({
        vendor,
        assetId,
        limit,
    }: {
        vendor: string;
        assetId: number;
        limit?: number;
    }): Promise<Asset[]> => {
        const query = [`ignoreAspectRatio=true`];
        if (limit) {
            query.push(`limit=${limit}`);
        }

        return relatedApi({
            path: `${vendor}/${assetId}`,
            query: query.join('&'),
        });
    },
};

export default relatedService;
